<template>
  <v-card
    :loading="loading"
    class="vacancies"
  >
    <v-card-title>Вакансии</v-card-title>
    <v-card-text>
      <p>Зарегистрированные вакансии:</p>
      <ul v-if="vacancies.length">
        <li v-for="vacancy in vacancies" :key="vacancy.id">
          <a :href="vacancy.link" target="_blank">{{ vacancy.title }}</a>
        </li>
      </ul>
      <p v-else-if="loading">загружается</p>
      <p v-else>нет зарегистрированных вакансий</p>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text color="primary" @click="update">
        Обновить список из HH
      </v-btn>
      <v-btn
        text
        color="deep-purple lighten-3"
        :disabled="loading"
        @click="load"
      >
        Перезагрузить
      </v-btn>

    </v-card-actions>
  </v-card>
</template>

<script>
import transport from "../../mixins/transport";

export default {
  name: "Vacancies",
  mixins: [transport],
  data(){
    return {
      vacancies:[],
      window: null
    }
  },
  mounted() {
    console.log('listener added');
    window.addEventListener("storage", this.catchUpdate);
    this.load();
  },
  methods:{
    load(){
      this.exchange(
        (items)=>{
          this.broadcastUpdate(items);
          this.vacancies=items;
        },
        null,
        'vacancies',
        'GET',
        'Вакансии обновлены'
      )
    },
    update(){
      this.window = window.open('https://arxminerals.kz/hh-parse');
    },
    broadcastUpdate(items){
      console.log('broadcastUpdate');
      sessionStorage.setItem('updateVacancies',JSON.stringify(items));
      sessionStorage.removeItem('updateVacancies');
    },
    catchUpdate(ev){
      console.log('catchUpdate');
      if (ev.key!=='updateVacancies') return;
      const items=JSON.parse(ev.newValue);
      if (!items) return; // ignore empty msg or msg reset
      this.vacancies = items;
      if(this.window)this.window.close();
    },
    uniqueID() {
      let result = "";
      const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 12; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return result;
    }
  }
}
</script>
